import { Injectable } from '@angular/core';
import { MatSnackBar, MatSnackBarConfig, MatSnackBarRef, TextOnlySnackBar } from '@angular/material/snack-bar';
import { environment } from '../../../environments/environment';

@Injectable({
	providedIn: 'root',
})
export class SnackbarService {
	private isWellsFargoPartner: boolean;

	constructor(private matSnackBar: MatSnackBar) {
		this.isWellsFargoPartner = false;
	}

	setPartnerConfig(partnerId: string): void {
		this.isWellsFargoPartner = partnerId === environment.wfPartnerId;
	}

	open(message: string, action?: string, config?: MatSnackBarConfig): MatSnackBarRef<TextOnlySnackBar> {
		if (this.isWellsFargoPartner) {
			config = { verticalPosition: 'top', horizontalPosition: 'center', ...config };
		}

		return this.matSnackBar.open(message, action, config);
	}
}
